export default ({ theme }) => ({
    '> .ant-layout': {
        height: '100vh',
    },
    '> .ant-layout > .ant-layout': {
        // 75rem = 1200px/16, 1200px is a bootstrap breakpoint
        maxWidth: '75rem',
        width: '100%',
        margin: 'auto',
    },
    '& .ant-layout-content': {
        margin: '1rem',
        padding: '1rem',
        backgroundColor: theme.colors.white,
    },
});
